import { createContext, useContext, useState } from "react";

interface ClientInfo {
  biz_code?: string;
  logo?: string;
  title?: string;
  [key: string]: any;
}

interface ClientContextProps {
  client: ClientInfo | null;
  setClient: (info: ClientInfo | null) => void;
}

const ClientContext = createContext<ClientContextProps>({
  client: null,
  setClient: () => {},
});

export const ClientProvider = ({ children }: any) => {
  const [client, setClient] = useState<ClientInfo | null>(null);

  return (
    <ClientContext.Provider value={{ client, setClient }}>
      {children}
    </ClientContext.Provider>
  );
};

export const useClient = () => useContext(ClientContext);